"use strict";

/* https://github.com/matthewhudson/current-device */
import Viewports from '../fsUtils/Viewports.js'

class FsBeacon {
    EpgTracking(props) { return new EpgTracking(props); }
}

/*
*   Note: props will be converted to escaped query string.
*   USAGE EXAMPLE:
*        let props = {
            postType: this.props.postType,
            content: this.props.state
        };
        FsBeacon.EpgTracking(props).send();
* */

class BaseTracking {
    constructor(props) {
        this.props = props || {};
        this.props.url = window.location.href;
        this.props.deviceType = (new Viewports()).isMobile ? 'Mobile' : 'Desktop';
    }

    send(url, props) {
        let queryString = jsonToQueryString(props);
        url += "?"+ queryString;
        goFetch(url);
    }
}

class EpgTracking extends BaseTracking {
    constructor(props) {
        super(props);
        this.props.campaign = "fsgo_epg";
        this.url = "/conv-epg";
    }

    send() {
        super.send(this.url, this.props);
    }
}

function jsonToQueryString(json) {
    return Object.keys(json).map(function(key) {
            return encodeURIComponent(key) + '=' + encodeURIComponent(json[key]);
        }).join('&');
}

function goFetch(url) {
    fetch(url).then(function (response) { /* intentionally left blank for future implementation. */ });
}

export default new FsBeacon();



// WEBPACK FOOTER //
// ./assets/components/fs-beacon/FsBeacon.js